import { render, staticRenderFns } from "./NavIcon.vue?vue&type=template&id=7ad49387&scoped=true"
import script from "./NavIcon.vue?vue&type=script&lang=js"
export * from "./NavIcon.vue?vue&type=script&lang=js"
import style0 from "./NavIcon.vue?vue&type=style&index=0&id=7ad49387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad49387",
  null
  
)

export default component.exports